var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-card", { staticClass: "employees-card-bottom" }, [
        _c(
          "div",
          [
            _c("formBox", {
              key: _vm.showText == "收起" ? 0 : 1,
              ref: "formBox",
              attrs: { notEmployees: _vm.notEmployees, total: _vm.total },
              on: {
                confirmData: _vm.confirmData,
                handleDelete: _vm.handleDelete,
                opendrawer: function ($event) {
                  return _vm.$emit("openDrawer", "addDrawerIsShow", "add")
                },
                showTextFn: _vm.showTextFn,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.pageLoading,
                    expression: "pageLoading",
                  },
                ],
              },
              [
                _c("Table", {
                  ref: "table",
                  attrs: {
                    showText: _vm.showText,
                    tableData: _vm.tableData,
                    total: _vm.total,
                  },
                  on: {
                    getList: _vm.getList,
                    limitFn: _vm.limitFn,
                    multipleSelection: _vm.multipleSelection,
                    pageFn: _vm.pageFn,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "options",
                      fn: function (ref) {
                        var data = ref.data
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["hr:archives:check"],
                                  expression: "['hr:archives:check']",
                                },
                              ],
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.hanldeOptions(data, "edit")
                                },
                              },
                            },
                            [_vm._v("查看\n            ")]
                          ),
                          _vm._v(" "),
                          data.status !== 0 && data.type !== 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.hanldeOptions(data, "worker")
                                    },
                                  },
                                },
                                [_vm._v("转正")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.type !== 2 || data.status !== 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.hanldeOptions(data, "quit")
                                    },
                                  },
                                },
                                [_vm._v("\n              离职\n            ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.status == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.hanldeOptions(
                                        data,
                                        "inviteToJoin"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              邀请完善信息\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.type !== 1 && data.status !== 1
                            ? _c(
                                "el-dropdown",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-dropdown-link el-button--text el-button",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("hr.more")) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    [
                                      data.type !== 1
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.hanldeOptions(
                                                    data,
                                                    "worker"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  转正\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.type !== 1
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.hanldeOptions(
                                                    data,
                                                    "quit"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  离职\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.status !== 1
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.hanldeOptions(
                                                    data,
                                                    "delete"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }